import styles from "./FlowFormPanel.module.less";

type FlowFormPanelLayoutProps = {
  showRightPanel?: boolean;
  leftPanel: React.ReactNode;
  rightPanel: React.ReactNode;
};

export function FlowFormPanelLayout(props: FlowFormPanelLayoutProps) {
  const { showRightPanel, leftPanel, rightPanel } = props;
  return (
    <div className={styles.panelContainer}>
      <div className={styles.leftPanel}>{leftPanel}</div>
      {showRightPanel && (
        <div className={styles.rightPanel}>
          <div className={styles.flowNodeListHeader}>流程动态</div>

          <div className={styles.flowNodeListContent}>{rightPanel}</div>
        </div>
      )}
    </div>
  );
}

type FormSectionLayoutProps = {
  body: React.ReactNode;
  footer?: React.ReactNode;
};

export function FormSectionLayout({ body, footer }: FormSectionLayoutProps) {
  return (
    <>
      <div className={styles.sectionBody}>{body}</div>

      {footer && <div className={styles.sectionFooter}>{footer}</div>}
    </>
  );
}
